@switch (timeline_item.card_type) {
    @case ('youtube') {
        <app-youtube-video-player
            [is_live_video]="timeline_item.data[0].is_live_video || false"
            [photo_url]="timeline_item.data[0].photo_url || ''"
            [videoId]="timeline_item.data[0].youtube_id || ''"
            [aspect_ratio]="aspect_ratio"
        >
        </app-youtube-video-player>
    }
    @case ('standalone') {
        <app-standlone-card [card]="timeline_item" [aspect_ratio]="aspect_ratio" [attr.data-card-id]="timeline_item.context.uuid" [timeline_id]="timeline_id"></app-standlone-card>
    }
    @case ('web_view') {
        <app-webview-card [card]="timeline_item" [aspect_ratio]="aspect_ratio" [attr.data-card-id]="timeline_item.context.uuid"></app-webview-card>
    }
    @case ('broadcast_schedule') {
        <app-broadcast-scheduled-card [card]="timeline_item" [aspect_ratio]="aspect_ratio" [attr.data-card-id]="timeline_item.context.uuid"></app-broadcast-scheduled-card>
    }
}
